import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const OuterWrapper = styled(Box)(({ theme }) => (`
    padding:10px 0;
    & .userType *{
        color:${theme.components.MuiTextField.styleOverrides.color};
    }
`))

export const Error = styled(Box)(`
    font-size:13px;
    color:red;
`)

export const Message = styled(Box)(`
    font-size:13px;
    color:green;
`)
